var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.chipProps.color}},[_vm._v(_vm._s(_vm.chipProps.text))])}
var staticRenderFns = []

export { render, staticRenderFns }